import {
  type AdConfigPlacement,
  AdServer,
  type AfsPlacement,
  type GamPlacement,
  type RetailMediaPlacement
} from './types/api/index.js';

export namespace Placements.Afs {
  export function is(placement: AdConfigPlacement): placement is AfsPlacement {
    return placement.adServer.type === AdServer.Afs;
  }

  export function filter(placements: ReadonlyArray<AdConfigPlacement>) {
    return placements.filter(is);
  }
}

export namespace Placements.Gam {
  export function is(placement: AdConfigPlacement): placement is GamPlacement {
    return placement.adServer.type === AdServer.Gam;
  }

  export function filter(placements: ReadonlyArray<AdConfigPlacement>) {
    return placements.filter(is);
  }
}

export namespace Placements.RetailMedia {
  export function is(
    placement: AdConfigPlacement
  ): placement is RetailMediaPlacement {
    return placement.adServer.type === AdServer.Retailmedia;
  }

  export function filter(placements: ReadonlyArray<AdConfigPlacement>) {
    return placements.filter(is);
  }
}
